import { Modal, Input, Select, Radio } from 'antd'
import { useEffect, useState } from 'react'
import Form from '$components/Form'
import { useTranslation } from 'react-i18next'

const GroupConfigModal = ({
  open,
  onCancel,
  onOk,
  groups,
  defaultGroupName,
  loading,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [defaultGroupNameState, setDefaultGroupNameState] = useState('')
  const groupOptions = groups?.map((g) => ({
    label: g.list_name,
    value: g.id,
  }))

  useEffect(() => {
    if (defaultGroupName) {
      setDefaultGroupNameState(defaultGroupName)
    }
  }, [defaultGroupName])

  return (
    <Modal
      open={open}
      title={t('parts_master_data.configure_group')}
      onCancel={onCancel}
      okText={t('add_button')}
      onOk={() => form.submit()}
      okButtonProps={{ loading }}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          groupType: 'new',
          groupName: defaultGroupNameState,
          existingGroupId: undefined,
        }}
        onFinish={onOk}
      >
        <Form.Item name="groupType">
          <Radio.Group>
            <Radio value="new">{t('parts_master_data.create_new_group')}</Radio>
            <Radio value="existing">
              {t('parts_master_data.add_to_existing_group')}
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) => prev.groupType !== curr.groupType}
        >
          {({ getFieldValue }) =>
            getFieldValue('groupType') === 'new' ? (
              <Form.Item
                name="groupName"
                label={t('parts_master_data.group_name')}
                rules={[
                  {
                    required: true,
                    message: t('parts_master_data.name_required'),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            ) : (
              <Form.Item
                name="existingGroupId"
                label={t('parts_master_data.select_existing_group')}
                rules={[
                  {
                    required: true,
                    message: t('parts_master_data.select_existing_group'),
                  },
                ]}
              >
                <Select
                  options={groupOptions}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            )
          }
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default GroupConfigModal
